var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.6694 25.6694C27.5 23.8389 27.5 20.8925 27.5 15C27.5 9.10744 27.5 6.16116 25.6694 4.33059C23.8389 2.5 20.8925 2.5 15 2.5C9.10744 2.5 6.16116 2.5 4.33059 4.33059C2.5 6.16116 2.5 9.10744 2.5 15C2.5 20.8925 2.5 23.8389 4.33059 25.6694C6.16116 27.5 9.10744 27.5 15 27.5C20.8925 27.5 23.8389 27.5 25.6694 25.6694Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4621 18.0871C12.096 18.4532 12.096 19.0467 12.4621 19.4129C12.8282 19.779 13.4217 19.779 13.7879 19.4129L17.5379 15.6629C17.7137 15.4871 17.8125 15.2486 17.8125 15C17.8125 14.7514 17.7137 14.5129 17.5379 14.3371L13.7879 10.5871C13.4217 10.221 12.8282 10.221 12.4621 10.5871C12.096 10.9532 12.096 11.5468 12.4621 11.9129L15.5491 15L12.4621 18.0871Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.f7ecbb48913ccb039a0945ebaa6a35d2.svg";
export { ForwardRef as ReactComponent };